import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { Provider } from "react-redux";
import { store } from "./store.ts";
import { ToastContainer } from "react-toastify";
import GlobalModals from "./GlobalModals.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <GlobalModals />
      <ToastContainer hideProgressBar />
      <App />
    </Provider>
  </StrictMode>
);
